module.exports = __webpack_public_path__ + "assets/img/lClass10.571ea0be.png";